/**
 * @generated SignedSource<<22571a22f7213364725ec898532448f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastDeviceInputMode = "SIGNAGE" | "TOUCH";
export type StorecastScreenAdminModeSelectorMutation$variables = {
  mode: StorecastDeviceInputMode;
  screenId: string;
};
export type StorecastScreenAdminModeSelectorMutation$data = {
  readonly storecast: {
    readonly setScreenInputMode: {
      readonly id: string;
      readonly inputMode: StorecastDeviceInputMode | null;
    };
  };
};
export type StorecastScreenAdminModeSelectorMutation$rawResponse = {
  readonly storecast: {
    readonly setScreenInputMode: {
      readonly id: string;
      readonly inputMode: StorecastDeviceInputMode | null;
    };
  };
};
export type StorecastScreenAdminModeSelectorMutation = {
  rawResponse: StorecastScreenAdminModeSelectorMutation$rawResponse;
  response: StorecastScreenAdminModeSelectorMutation$data;
  variables: StorecastScreenAdminModeSelectorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenId"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorecastMutation",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "inputMode",
            "variableName": "mode"
          },
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "screenId"
          }
        ],
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "setScreenInputMode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inputMode",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenAdminModeSelectorMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StorecastScreenAdminModeSelectorMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "63b5582695f5a3691d1b6dda4c973f02",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenAdminModeSelectorMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastScreenAdminModeSelectorMutation(\n  $screenId: ID!\n  $mode: StorecastDeviceInputMode!\n) {\n  storecast {\n    setScreenInputMode(screenId: $screenId, inputMode: $mode) {\n      id\n      inputMode\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "310508feb4d104693b2c37c2df63ccad";

export default node;
